export default __webpack_public_path__ + "static/media/blurred-payment-bg.25521bd8.png";